import { addEvent } from "@stikipixels/analytics-browser";

export default {
  recommend(size) {
    addEvent({ type: "daisy.recommend", payload: { size } });
  },
};
